import classnames from 'classnames';
import React from 'react';
import MenuItemLink from '~/reusable-components/navigation/NavigationMenuList/MenuItemLink';

const CSS = require('./MenuItem.module.scss');

interface MenuItemProps {
  text: string;
  url?: string;
  badgeNumber?: number;
  onClick?: () => void;
  isExternalLink?: boolean;
  openModal?: boolean;
  isActive?: boolean;
  addReturnTo?: boolean;
  openInNewTab?: boolean;
  noAuth?: boolean;
}

function MenuItem({
  text,
  url,
  badgeNumber,
  onClick,
  isExternalLink,
  openModal,
  isActive,
  addReturnTo = false,
  openInNewTab = false,
  noAuth = false,
}: MenuItemProps) {
  const classes = classnames(CSS.MenuItem, { [CSS.ActiveMenuItem]: isActive });
  return (
    <div className={classes}>
      <MenuItemLink
        addReturnTo={addReturnTo}
        url={url}
        isExternalLink={isExternalLink}
        onClick={onClick}
        className={CSS.Link}
        text={text}
        openModal={openModal}
        openInNewTab={openInNewTab}
        noAuth={noAuth}
      />
      {(badgeNumber ?? 0) > 0 && (
        <span className={CSS.MenuBadge}>{badgeNumber}</span>
      )}
    </div>
  );
}

export default MenuItem;
